import { useCallback, useState } from "react";
import { GlobalButton } from "../../global/forms/GlobalFormFields";
import { initiatePayment } from "./paymentApi";
import { beginPhonePeRedirect } from "./paymentSession";

export default function GlobalPaymentButton({
  amount,
  label = "Pay Now",
  disabled = false,
  variant = "primary",
  className,
  onError,
  onBeforeRedirect,
}) {
  const [loading, setLoading] = useState(false);

  const handlePay = useCallback(async () => {
    const value = Number(amount);

    if (!value || value < 1) {
      onError?.("Minimum amount is ₹1");
      return;
    }

    setLoading(true);

    try {
      const data = await initiatePayment(value);

      if (data.success && data.paymentResponse?.redirectUrl) {
        onBeforeRedirect?.();
        beginPhonePeRedirect(data.merchantOrderId);
        window.location.href = data.paymentResponse.redirectUrl;
        return;
      }

      onError?.(data.message || "Could not start payment");
    } catch (err) {
      onError?.(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [amount, onError, onBeforeRedirect]);

  return (
    <GlobalButton
      type="button"
      variant={variant}
      className={className}
      disabled={disabled || loading}
      loading={loading}
      onClick={handlePay}
    >
      {label}
    </GlobalButton>
  );
}
